import React, { useId } from 'react';
import { Path } from 'react-native-svg';
import { IconWithGradient } from 'design-system/icons/Icon';
export const IconMedal = (props) => {
    const id = useId();
    return (<IconWithGradient id={id} {...props} defaultGradientKey="plus">
      <Path fill={`url(#gradient_${id})`} d="M12 15.5c3.728 0 6.75-2.91 6.75-6.5S15.728 2.5 12 2.5 5.25 5.41 5.25 9s3.022 6.5 6.75 6.5Z"/>
      <Path fill={`url(#gradient_${id})`} d="M15.79 16.11c.33-.17.71.08.71.45v4.85c0 .9-.63 1.34-1.41.97l-2.68-1.27c-.23-.1-.59-.1-.82 0l-2.68 1.27c-.78.36-1.41-.08-1.41-.98l.02-4.84c0-.37.39-.61.71-.45 1.13.57 2.41.89 3.77.89 1.36 0 2.65-.32 3.79-.89Z"/>
    </IconWithGradient>);
};
